import * as React from 'react';
import classNames from 'classnames';

interface Props
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  children: React.ReactNode;
  className?: string;
  isCancel?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent) => void;
}

export default function EdgeButton({
  children,
  type = 'button',
  className = '',
  isCancel = false,
  disabled,
  style,
  onClick,
}: Props) {
  // クリック音は AudioContext のグローバルリスナーが鳴らすので個別ハンドラは不要

  // isCancel用のスタイル（従来通り）
  const cancelClass =
    'bg-[url("/images/button_secondary_dark.png")] w-[168px] h-[100px] s:w-[148px] s:h-[56px] xs:w-[148px] xs:h-[56px] bg-contain bg-center bg-no-repeat';

  // 通常ボタン用のスタイル（アスペクト比504:240を維持、幅はchildrenに応じて変動）
  const normalClass =
    'bg-[url("/images/button_send_no.png")] bg-[length:100%_100%] bg-center bg-no-repeat px-8 py-2 min-w-[120px]';

  const baseClass = isCancel ? cancelClass : normalClass;

  const commonClass =
    'edge-button active-scale-90 text-2xl text-brown-secondary text-stroke opacity-100 s:text-sm xs:text-base whitespace-nowrap';

  const hoverClass = 'opacity-100';
  const disabledClass = '!opacity-50';

  const buttonClass = classNames(baseClass, commonClass, className, {
    [hoverClass]: !disabled,
    [disabledClass]: disabled,
  });

  // 通常ボタンの場合、アスペクト比504:240を維持
  const aspectRatioStyle = !isCancel ? { aspectRatio: '504 / 240' } : {};

  return (
    <button
      type={type}
      className={buttonClass}
      disabled={disabled}
      style={{ ...aspectRatioStyle, ...style }}
      onClick={onClick}
    >
      <p className={`${isCancel ? 'mb-1' : ''} pb-1 text-sm`}>{children}</p>
    </button>
  );
}
